<div class="data-page working-area">
    <div class="row">
        <div class="col-4">
            <kendo-grid [kendoGridBinding]="gridData" [pageSize]="25" [pageable]="true" [sortable]="true" [resizable]="true" [filterable]="true" [rowClass]="gridCallback" [selectable]="selectableSettings" (cellClick)="cellClickHandler($event)">
                <kendo-grid-column field="id" title="ID" [width]="50" [filterable]="false"></kendo-grid-column>
                <kendo-grid-column field="title" title="Title"></kendo-grid-column>
            </kendo-grid>
        </div>
        <div class="col-8">
            <div class="card active-blog" id="entityEditForm" *ngIf="activeBlog">
                <div class="card-header">
                    <div style="display: inline;">
                        Edit Blog
                    </div>
                    <div style="float:right;">
                        <div style="display: flex;">
                            <mat-checkbox [(ngModel)]="activeBlog.isActive" (change)="toggleBlogActive(activeBlog)">Active</mat-checkbox>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <mat-form-field>
                                <mat-label>Author *</mat-label>
                                <input matInput [(ngModel)]="activeBlog.author" />
                                <mat-error [hidden]="this.valid">Author is required</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col">
                            <mat-form-field>
                                <mat-label>Title *</mat-label>
                                <input matInput [(ngModel)]="activeBlog.title" required/>
                                <mat-error [hidden]="this.valid">Title is required</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <mat-form-field>
                                <mat-label>Sub-Title</mat-label>
                                <input matInput [(ngModel)]="activeBlog.subtitle" />
                            </mat-form-field>
                        </div>
                        <div class="col">
                            <mat-form-field>
                                <mat-select [(ngModel)]="activeBlog.thumbnailImage" (selectionChange)="updateBlogImage()" required>
                                    <mat-option *ngFor="let image of imageList" [value]="image.name">
                                        <img style="width: 40px; margin-right: 10px;" [src]="'../' + image.name" />{{image.name}}
                                    </mat-option>
                                </mat-select>                                
                                <mat-label *ngIf="activeBlog.thumbnailImage; else hint">Blog Image</mat-label>                                
                                <ng-template #hint>Upload blog image</ng-template>
                                <mat-progress-bar [value]="file?.progress" *ngIf="uploading"></mat-progress-bar>                                                             
                                <button mat-button class="file-upload" matSuffix mat-icon-button aria-label="Clear" title="Upload image" (click)="onClick()">                                   
                                        <fa-icon *ngIf="!uploading" [icon]="['fas', 'save']"></fa-icon>     
                                        <fa-icon *ngIf="uploading" [icon]="['fas', 'spinner']" [spin]="true"></fa-icon>                                                                
                                </button>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <mat-form-field>
                                <mat-label>Breif</mat-label>
                                <textarea matInput rows="3" style="line-height: 2em;" [(ngModel)]="activeBlog.introduction" required></textarea>
                            </mat-form-field>
                        </div>
                        <div class="col">

                            <mat-label>Topics</mat-label>
                            <mat-selection-list #list [(ngModel)]="activeBlog.topics" [compareWith]="isTopicSelected" (selectionChange)="updateTopic($event)">
                                <mat-list-option *ngFor="let topic of topics" [value]="topic" [disableRipple]="true">
                                    <div style="display:flex; justify-content:space-between;align-items:center">
                                        <div>{{topic.name}}</div>
                                        <button mat-icon-button (click)="editTopic($event, topic)" title="Click to edit Topic"><fa-icon [icon]="['fas', 'edit']"></fa-icon></button>
                                    </div>
                                </mat-list-option>
                            </mat-selection-list>
                        </div>
                    </div>
                    <kendo-editor [(ngModel)]="activeBlog.body" style="height: 400px;">
                        <kendo-toolbar>
                            <kendo-toolbar-buttongroup>
                                <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                            </kendo-toolbar-buttongroup>
                            <kendo-toolbar-buttongroup>
                                <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                            </kendo-toolbar-buttongroup>
                            <kendo-toolbar-buttongroup>
                                <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
                            </kendo-toolbar-buttongroup>
                            <kendo-toolbar-buttongroup>
                                <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                            </kendo-toolbar-buttongroup>
                            <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
                            <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                            <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                            <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
                            <kendo-toolbar-colorpicker kendoEditorBackColor></kendo-toolbar-colorpicker>
                            <kendo-toolbar-buttongroup>
                                <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                            </kendo-toolbar-buttongroup>
                            <kendo-toolbar-buttongroup>
                                <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                            </kendo-toolbar-buttongroup>
                            <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
                            <kendo-toolbar-buttongroup>
                                <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
                            </kendo-toolbar-buttongroup>
                            <kendo-toolbar-buttongroup>
                                <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
                            </kendo-toolbar-buttongroup>
                            <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
                        </kendo-toolbar>
                    </kendo-editor>
                </div>
                <div class="card-footer">
                    <button class="btn btn-primary" (click)="addBlog()">
                        <fa-icon [icon]="['fas', 'plus']"></fa-icon>Add New
                    </button>
                    <button class="btn btn-success" (click)="saveBlog()" [disabled]="getHasErrors()" [ngClass]="{'error': getHasErrors()}"> 
                    <ng-container *ngIf="saving; then tplSaveing; else tplSaved"></ng-container>
                        <ng-template #tplSaved><fa-icon [icon]="['fas', 'save']"></fa-icon></ng-template> 
                        <ng-template #tplSaveing><fa-icon [icon]="['fas', 'spinner']" [spin]="true" size="lg"></fa-icon></ng-template>                                                                             
                        Save
                    </button>
                </div>
                <input type="file" #fileUpload id="fileUpload" name="fileUpload" multiple="multiple" accept="*" style="display:none;" />
            </div>
        </div>
    </div>